import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '~/services/queryClient'
import { getEDITransactionCodes } from '~/services/staticService'

export interface EDITransactionCodes {
  [key: string]: string[]
}

export function useEDITransactionCodes() {
  return useQuery<EDITransactionCodes>({
    queryKey: QueryKeys.EDITransactionCodes,
    queryFn: getEDITransactionCodes
  })
}
